document.documentElement.classList.remove('no-js');

(() => {
  const WISHLIST_KEY = 'ethoes_wishlist_v1';

  function getWishlist() {
    try {
      const value = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    updateWishlistUI();
    renderWishlistPage();
  }

  function productFromButton(button) {
    return {
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || 'Product',
      url: button.dataset.productUrl || '#',
      price: button.dataset.productPrice || '',
      image: button.dataset.productImage || '',
      variantId: button.dataset.variantId || ''
    };
  }

  function toggleWishlist(button) {
    const product = productFromButton(button);
    if (!product.handle) return;

    const items = getWishlist();
    const index = items.findIndex(item => item.handle === product.handle);

    if (index >= 0) {
      items.splice(index, 1);
      showToast('Removed from wishlist');
    } else {
      items.unshift(product);
      showToast('Added to wishlist');
    }

    saveWishlist(items);
  }

  function updateWishlistUI() {
    const items = getWishlist();
    const handles = new Set(items.map(item => item.handle));

    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? 'Saved to wishlist' : 'Add to wishlist';
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(count => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  }

  function renderWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid || !empty) return;

    const items = getWishlist();
    grid.replaceChildren();
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;

    items.forEach(item => {
      const card = document.createElement('article');
      card.className = 'product-card wishlist-card';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-button is-active';
      remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
      remove.dataset.wishlistRemove = item.handle;
      remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.8a5.5 5.5 0 0 0-7.8 0L12 5.9l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z"></path></svg>';

      const link = document.createElement('a');
      link.className = 'product-card-link';
      link.href = item.url;

      const media = document.createElement('div');
      media.className = 'product-card-media';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        media.appendChild(image);
      }

      const info = document.createElement('div');
      info.className = 'product-card-info';
      const title = document.createElement('div');
      title.className = 'product-title';
      title.textContent = item.title;
      const price = document.createElement('div');
      price.className = 'price';
      price.textContent = item.price;
      info.append(title, price);
      link.append(media, info);
      card.append(remove, link);
      grid.appendChild(card);
    });
  }

  function removeWishlistItem(handle) {
    saveWishlist(getWishlist().filter(item => item.handle !== handle));
    showToast('Removed from wishlist');
  }

  function showToast(message) {
    let toast = document.querySelector('[data-theme-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'theme-toast';
      toast.dataset.themeToast = '';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(window.ethoesToastTimer);
    window.ethoesToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  }

  async function handleShare(button) {
    const data = {
      title: button.dataset.shareTitle || document.title,
      text: button.dataset.shareText || '',
      url: button.dataset.shareUrl || window.location.href
    };

    if (navigator.share) {
      try {
        await navigator.share(data);
        return;
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Share failed:', error);
        if (error.name === 'AbortError') return;
      }
    }

    const menu = document.querySelector('[data-share-menu]');
    if (!menu) return;
    const whatsapp = menu.querySelector('[data-share-whatsapp]');
    const facebook = menu.querySelector('[data-share-facebook]');
    whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${data.title} ${data.url}`)}`;
    facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(data.url)}`;
    menu.dataset.shareUrl = data.url;
    menu.hidden = !menu.hidden;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-mobile-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? '×' : '☰';
      });
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('revealed');
      }), { threshold: 0.12 });
      document.querySelectorAll('[data-reveal]').forEach(element => observer.observe(element));
    }

    updateWishlistUI();
    renderWishlistPage();
  });

  document.addEventListener('click', async event => {
    const wishlistButton = event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      removeWishlistItem(removeButton.dataset.wishlistRemove);
      return;
    }

    const shareButton = event.target.closest('[data-product-share]');
    if (shareButton) {
      await handleShare(shareButton);
      return;
    }

    const copyButton = event.target.closest('[data-share-copy]');
    if (copyButton) {
      const menu = copyButton.closest('[data-share-menu]');
      await copyText(menu?.dataset.shareUrl || window.location.href);
      showToast('Product link copied');
      if (menu) menu.hidden = true;
    }
  });
})();

// ETHOES product image gallery
(() => {
  function initProductGallery(gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    const main = gallery.querySelector('.product-gallery-main');
    if (slides.length < 2) return;

    let index = 0;
    let touchStartX = null;

    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1);
      thumbs[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));

    main?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    main?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 45) return;
      show(delta < 0 ? index + 1 : index - 1);
    }, { passive: true });

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  const initialize = () => document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
